import React,{useState} from 'react'
import { Link } from 'react-router-dom'

import Navbar from '../../components/navbar'
import BgParallax from '../../components/bg-parallax'
import ClientTwo from '../../components/client-two'
import TeamOne from '../../components/team-one'
import Counter from '../../components/counter'

import bg1 from '../../assets/images/app/bg.jpg'
import bg2 from '../../assets/images/app/bg-shape.png'
import mobile from '../../assets/images/app/mobile01.png'
import mobile2 from '../../assets/images/app/mobile-hori.png'
import app from '../../assets/images/app/01.png'
import app2 from '../../assets/images/app/02.png'
import cta from '../../assets/images/app/cta.jpg'

import ModalVideo from 'react-modal-video';
import '../../../node_modules/react-modal-video/scss/modal-video.scss'

import { appFeature } from '../../data/data'
import Footer from '../../components/footer'

export default function IndexApplication() {
  let [isOpen, setOpen] = useState(false);
  return (
    <>
     <Navbar navLight={true}/> 

    <section className="bg-half-170 bg-light d-table w-100" id="home">
    <BgParallax bg={bg1}/>
      <div className="bg-overlay bg-overlay-primary"></div>
      <div className="container">
          <div className="row align-items-center position-relative" style={{zIndex:'1'}}>
              <div className="col-lg-7 col-md-6">
                  <div className="title-heading text-center text-md-start mt-4">
                      <h1 className="heading text-white title-dark mb-3">Great app that makes your life awesome - Leaping</h1>
                      <p className="para-desc text-light title-dark">Start work with Leaping. Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                      <div className="mt-4">
                          <Link to="#" className="btn btn-light mouse-down"><i className="mdi mdi-download"></i> Install Now</Link>
                      </div>
                  </div>
              </div>

              <div className="col-lg-5 col-md-6 mt-4 pt-2">
                  <div className="home-img position-relative">
                      <img src={mobile} className="img-fluid d-block mx-auto" alt=""/>
                      <div className="play-icon">
                          <Link to="#" onClick={() => setOpen(true)} className="play-btn lightbox video-play-icon">
                              <i className="mdi mdi-play text-primary rounded-pill bg-dark shadow"></i>
                          </Link>
                      </div>
                      <ModalVideo
                          channel="youtube"
                          youtube={{ mute: 0, autoplay: 0 }}
                          isOpen={isOpen}
                          videoId="yba7hPeTSjk"
                          onClose={() => setOpen(false)} 
                        />
                  </div>
              </div>
          </div>
      </div>
      <div className="home-shape d-block">
          <img src={bg2} alt="" className="img-fluid mx-auto d-block"/>
      </div>
    </section>

    <section className="section pt-5">
      <div className="container">
          <div className="row justify-content-center">
              <div className="col-12 text-center">
                  <div className="section-title mb-4 pb-2">
                      <h4 className="title mb-4">Application Features</h4>
                      <p className="text-muted para-desc mx-auto mb-0">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                  </div>
              </div>
          </div>

          <div className="row">
            {appFeature.map((item,index)=>{
              let Icon = item.icon
              return(
                <div className="col-lg-3 col-md-4 col-12 mt-4 pt-2" key={index}>
                    <div className="feature p-3 py-5 rounded text-center">
                        <i className="h1 text-primary"><Icon/></i>
                        <div className="content">
                            <h4 className="title mt-3">{item.title}</h4>
                            <p className="text-muted mt-2 mb-0">{item.desc}</p>
                        </div>
                    </div>
                </div>
              )
            })}
          </div>

          <div className="row justify-content-center mt-4 pt-4">
              <div className="col-md-10">
                  <img src={mobile2} className="img-fluid d-block mx-auto" alt=""/>
              </div>
              <div className="col-12 text-center pt-2">
                  <div className="alert alert-dark alert-pills mb-0" role="alert">
                      <span className="badge bg-success rounded-pill"> Download </span>
                      <span className="alert-content ms-2"> Trusted by the world's best <i className="mdi mdi-download"></i></span>
                  </div>
              </div>
          </div>
      </div>

      <div className="container mt-100 mt-60">
          <div className="row align-items-center">
              <div className="col-lg-5 col-md-6">
                  <img src={app} className="img-fluid" alt=""/>
              </div>

              <div className="col-lg-7 col-md-6 mt-4 mt-sm-0 pt-2 pt-sm-0">
                  <div className="section-title ms-md-5">
                      
                      <h4 className="title mt-3 mb-4">Build Beautiful & Modular Application</h4>
                      <p className="text-muted para-desc">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                      <ul className="list-inline mb-0">
                          <li className="h6"><i className="mdi mdi-check-circle-outline text-primary h5 mb-0 me-2 align-middle"></i> Can I upgrade later on?</li>
                          <li className="h6"><i className="mdi mdi-check-circle-outline text-primary h5 mb-0 me-2 align-middle"></i> Can I port my data from another provider?</li>
                          <li className="h6"><i className="mdi mdi-check-circle-outline text-primary h5 mb-0 me-2 align-middle"></i> Are my food photos stored forever in the cloud?</li>
                          <li className="h6"><i className="mdi mdi-check-circle-outline text-primary h5 mb-0 me-2 align-middle"></i> Who foots the bill for that?</li>
                      </ul>
                      <div className="mt-4">
                          <Link to="#" className="text-primary">Learn More <i className="mdi mdi-chevron-right align-middle"></i></Link>
                      </div>
                  </div>
              </div>
          </div>
      </div>
    </section>

    <section className='position-relative'>
      <BgParallax bg={cta}/>
        <div className="container">
            <div className="row">
                <div className="col-lg-4 col-md-6">
                    <div className="cta-review bg-dark shadow rounded p-4">
                        <ClientTwo/>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section className="section">
      <div className="container">
          <div className="row mt-5 pt-4 align-items-center">
              <div className="col-lg-5 col-md-6 order-1 order-md-2 text-end">
                  <img src={app2} className="img-fluid" alt=""/>
              </div>

              <div className="col-lg-7 col-md-6 order-2 order-md-1 mt-4 mt-sm-0 pt-2 pt-sm-0">
                  <div className="section-title me-md-5">
                      <span className="badge bg-primary"> Hot </span>
                      <h4 className="title mt-3 mb-4">Less working, More sales flow.</h4>
                      <p className="text-muted para-desc">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                      <ul className="list-inline mb-0">
                          <li className="h6"><i className="mdi mdi-check-circle-outline text-primary h5 mb-0 me-2 align-middle "></i> Can I upgrade later on?</li>
                          <li className="h6"><i className="mdi mdi-check-circle-outline text-primary h5 mb-0 me-2 align-middle "></i> Can I port my data from another provider?</li>
                          <li className="h6"><i className="mdi mdi-check-circle-outline text-primary h5 mb-0 me-2 align-middle "></i> Are my food photos stored forever in the cloud?</li>
                          <li className="h6"><i className="mdi mdi-check-circle-outline text-primary h5 mb-0 me-2 align-middle "></i> Who foots the bill for that?</li>
                      </ul>
                      <div className="mt-4">
                          <Link to="#" className="text-primary">Read More <i className="mdi mdi-chevron-right align-middle"></i></Link>
                      </div>
                  </div>
              </div>
          </div>
      </div>

      <div className="container mt-100 mt-60">
          <div className="row">
              <div className="col-12 text-center">
                  <div className="section-title">
                      <h4 className="title mb-4">Our Creative Minds</h4>
                      <p className="text-muted para-desc mx-auto mb-0">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                  </div>
              </div>
          </div>
          <TeamOne/>
      </div>

      <div className="container mt-100 mt-60">
          <Counter/>
      </div>

      <div className="container mt-100 mt-60 mb-3 mb-md-5" id="downloadnow">
          <div className="row justify-content-center">
              <div className="col-12 text-center">
                  <div className="section-title">
                      <h4 className="title mb-4 pb-2">Get the App now !</h4>
                      <p className="text-muted para-desc mx-auto">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                      <div className="mt-4 pt-2">
                          <Link to="#" className="btn btn-primary mt-2 me-2"><i className="mdi mdi-apple"></i> App Store</Link>
                          <Link to="#" className="btn btn-outline-primary mt-2"><i className="mdi mdi-google-play"></i> Play Store</Link>
                      </div>
                  </div>
              </div>
          </div>
      </div>
    </section>

    <div className="position-relative">
      <div className="shape overflow-hidden text-footer">
          <svg viewBox="0 0 2880 250" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M720 125L2160 0H2880V250H0V125H720Z" fill="currentColor"></path>
          </svg>
      </div>
    </div>
    <Footer/>
    </>
  )
}
